<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <SelectPlatforms ref="platformSelector" />
    <v-row no-gutters>
      <v-col cols="12">
        <GlobalNav></GlobalNav>
      </v-col>
      <v-col cols="12">
        <div class="d-flex h-100">
          <SideBar></SideBar>
          <div class="pa-5 w-100">
            <BreadCrumb :linksData="linksData" class="mb-5" />
            <div class="d-flex justify-end mb-3">
              <v-btn color="#237276" variant="outlined" @click="changeSelection">
                Change platforms and accounts
              </v-btn>
            </div>
            <StepperComponent
              :current-step="step"
              @update:currentStep="step = $event"

              :steps="stepLabels"
            />
            <v-row
              class="mt-5"
              v-if="store.campaignObjective === 'video_views'"
            >
              <v-col cols="8" :sm="12" :md="12" :lg="8">
                <VedioViews
                  v-if="step === 0"
                  :campaign-name="campaignName"
                  :campaign-objective="campaignObjective"
                  :status="status"
                  @update:campaignName="campaignName = $event"
                  @update:campaignObjective="campaignObjective = $event"
                  @update:status="status = $event"
                  @next="step++"
                />
                <StepTwo v-else-if="step === 1" @next="step++" @prev="step--" />

                <StepThree
                  v-else-if="step === 2 && !reviewMode"
                  @prev="step--"
                  @submit="reviewMode = true"
                />
                <ReviewPage
                  v-else-if="step === 2 && reviewMode"
                  @exit-review="reviewMode = false"
                  @go-to-step="step = $event"
                />
              </v-col>
              <v-col cols="4" :sm="12" :md="12" :lg="4">
                <AdPreviewBox v-if="step === 2 && !reviewMode" />
              </v-col>
            </v-row>
            <v-row class="mt-5" v-if="store.campaignObjective === 'awareness'">
              <v-col cols="8" :sm="12" :md="12" :lg="8">
                <AwarenessFlow
                  :step="step"
                  :review-mode="reviewMode"
                  :campaign-name="campaignName"
                  :campaign-objective="campaignObjective"
                  :status="status"
                  @update:step="step = $event"
                  @update:reviewMode="reviewMode = $event"
                  @update:campaignName="campaignName = $event"
                  @update:campaignObjective="campaignObjective = $event"
                  @update:status="status = $event"
                />
              </v-col>
              <v-col cols="4" :sm="12" :md="12" :lg="4">
                <AdPreviewBox v-if="step === 2 && !reviewMode" />
              </v-col>
            </v-row>

            <v-row class="mt-5" v-if="store.campaignObjective === 'leads'">
              <v-col cols="8" :sm="12" :md="12" :lg="8">
                <AwarenessFlow
                  :step="step"
                  :review-mode="reviewMode"
                  :campaign-name="campaignName"
                  :campaign-objective="campaignObjective"
                  :status="status"
                  @update:step="step = $event"
                  @update:reviewMode="reviewMode = $event"
                  @update:campaignName="campaignName = $event"
                  @update:campaignObjective="campaignObjective = $event"
                  @update:status="status = $event"
                />
              </v-col>
              <v-col cols="4" :sm="12" :md="12" :lg="4">
                <AdPreviewBox v-if="step === 2 && !reviewMode" />
              </v-col>
            </v-row>

          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import StepperComponent from "@/components/SuperApp/Stepper.vue";
import VedioViews from "@/components/SuperApp/VedioViews.vue";
import StepTwo from "@/components/SuperApp/StepTwo.vue";
import StepThree from "@/components/SuperApp/StepThree.vue";
import AdPreviewBox from "@/components/SuperApp/StepTree/AdPreviewBox.vue";
import SelectPlatforms from "@/components/SuperApp/SelectPlatforms.vue";
import { useSuperAddStore } from "@/store/superAddStore";
import ReviewPage from "@/components/SuperApp/ReviewPage.vue";
import AwarenessFlow from "@/components/SuperApp/Awareness/AwarenessFlow.vue";

export default {
  name: "SupperAdd",
  components: {
    BreadCrumb,
    GlobalNav,
    SideBar,
    VedioViews,
    StepperComponent,
    StepTwo,
    StepThree,
    AdPreviewBox,
    SelectPlatforms,
    ReviewPage,
    AwarenessFlow,

  },
  data() {
    return {
      store: useSuperAddStore(),
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Super Ad", link: "/super-ad" },
      ],
      step: 0,
      reviewMode: false,
      campaignName: "Video views campaign",
      campaignObjective: "Video views",
      status: true,
      selectedObjective: null,
    };
  },
  methods: {
    changeSelection() {
      this.step = 0;
      this.reviewMode = false;
      this.$refs.platformSelector.openSelection();
    },
    nextStep() {
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
  },
  computed: {
    stepLabels() {
      const map = {
        video_views: "Video Views",
        awareness: "Awareness",
        leads: "Lead Generation",
        traffic: "Traffic",
      };

      const objectiveLabel =
        map[this.store.campaignObjective] ||
        this.store.campaignObjective
          .replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());

      return [`${objectiveLabel} campaign`, "Ad set", "Ad"];
    },
    steps() {
      return ["Step 1", "Step 2", "Step 3", "step 4"];

    },
  },
  mounted() {
    const savedObjective = localStorage.getItem("superselected_objective");
    if (savedObjective) {
      this.selectedObjective = savedObjective;
    }
  },
};
</script>
